import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass.js';


// Texture imports
import starsTexture from '../img/stars.jpg';
import sunTexture from '../img/sun.jpg';
import mercuryTexture from '../img/mercury.jpg';
import venusTexture from '../img/venus.jpg';
import earthTexture from '../img/earth.jpg';
import marsTexture from '../img/mars.jpg';
import jupiterTexture from '../img/jupiter.jpg';
import saturnTexture from '../img/saturn.jpg';
import saturnRingTexture from '../img/saturn_ring.png';
import uranusTexture from '../img/uranus.jpg';
import uranusRingTexture from '../img/uranus_ring.png';
import neptuneTexture from '../img/neptune.jpg';
import plutoTexture from '../img/pluto.jpg';
import milkyWayGalaxy from '../img/milky way galaxy.jpeg';
import galaxy1 from '../img/galaxy1.jpg';
import galaxy2 from '../img/galaxy2.jpg';
import galaxy3 from '../img/galaxy3.jpg';
import galaxy4 from '../img/galaxy4.jpg';
import galaxy5 from '../img/galaxy5.jpg';
import galaxy6 from '../img/galaxy6.jpg';
import galaxy7 from '../img/galaxy7.jpg';
import galaxy8 from '../img/galaxy8.jpg';
import galaxy9 from '../img/galaxy9.jpg';


window.onload = function () {
// Select the loading indicator element
const loadingIndicator = document.getElementById('loadingIndicator');

// Hide the loading indicator after a specified delay (e.g., 6 seconds)
setTimeout(() => {
  loadingIndicator.style.display = 'none'; // Hide the loading indicator

  // Start the camera animation after the loading is done
  requestAnimationFrame(animateCamera);
}, 6000); // Adjust this value for longer/shorter loading times

// Declare initial camera position first
const initialCameraDistance = 3500; // Final distance for the Z-axis

// Camera animation setup
const startCameraPosition = { x: 0, y: 5000000, z: 5000000 }; // Start far from the scene
const endCameraPosition = { x: 6000, y: 6000, z: initialCameraDistance }; // End at {x: 6000, y: 6000, z: 3500}
const animationDuration = 3000; // Duration of animation in milliseconds (3 seconds)
let startTime = null;

// Function to animate the camera position
function animateCamera(timestamp) {
  if (!startTime) startTime = timestamp;
  const elapsedTime = timestamp - startTime;

  // Calculate the interpolation factor (0 to 1 based on the time)
  const t = Math.min(elapsedTime / animationDuration, 1);

  // Interpolate camera position using linear interpolation
  camera.position.x = startCameraPosition.x + t * (endCameraPosition.x - startCameraPosition.x);
  camera.position.y = startCameraPosition.y + t * (endCameraPosition.y - startCameraPosition.y);
  camera.position.z = startCameraPosition.z + t * (endCameraPosition.z - startCameraPosition.z);

  // Update the camera to look at the Sun (or any center point)
  camera.lookAt(0, 0, 0);

  // Update the orbit controls
  orbit.update();

  // Render the scene
  renderer.render(scene, camera);

  // Continue the animation if it's not finished
  if (t < 1) {
    requestAnimationFrame(animateCamera);
  }
}


  // Add these lines at the top of your script to declare the modal and buttons
  const confirmationModal = document.getElementById('confirmationModal');
  const goToPageButton = document.getElementById('goToPage');
  const closeModalButton = document.getElementById('closeModal');
  const planetMessage = document.getElementById('planetMessage');
  const parentDiv = document.getElementById('parentDiv');

  // Add an event listener for the "Go to Page" button
  goToPageButton.addEventListener('click', () => {
    // Navigate to another page based on the selected planet name
    const planetName = planetsData[window.selectedPlanetIndex].planetName; // Use the updated planetsData
    console.log(planetName);

    // Make sure to navigate to the right page based on planet name
    window.location.href = `../${planetName}.html`;
  });


  // Add an event listener for the "Close" button
  closeModalButton.addEventListener('click', () => {
    confirmationModal.style.display = 'none'; // Hide the modal
    parentDiv.style.display = 'none'; // Hide the modal
    planetMessage.parentElement.style.display = 'none'; // Hide the message div
  });

  // Function to handle mouse clicks
  function onMouseClick(event) {
    // Update mouse coordinates for click position
    mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

    // Raycasting to detect intersection
    raycaster.setFromCamera(mouse, camera);
    const intersects = raycaster.intersectObjects(planetOrbitsAndMeshes.map(p => p.planetMesh));

    if (intersects.length > 0) {
      const clickedPlanet = intersects[0].object;

      // Get the index of the clicked planet
      const planetIndex = planetOrbitsAndMeshes.findIndex(p => p.planetMesh === clickedPlanet);

      if (planetIndex !== -1) {
        // Get the target position of the clicked planet using planetPositions
        const targetPosition = planetPositions[planetIndex]; // Access stored position

        // Store the selected planetIndex and targetPosition globally
        window.selectedPlanetIndex = planetIndex;
        window.selectedTargetPosition = targetPosition;

        // Show the confirmation modal and parent div
        parentDiv.style.display = 'flex'; // Make parent div visible
        confirmationModal.style.display = 'block'; // Display modal to ask user action

        // Display the message in the message div
        const planetName = planetsData[planetIndex].planetName; // Accessing the planet name from the updated planetsData
        planetMessage.innerText = `Hello My Name ${planetName}!`;
        planetMessage.parentElement.style.display = 'block'; // Show the message div

        // Log the selected target position
        console.log('Selected Target Position:', window.selectedTargetPosition);
      }
    } else {
      // If click is outside any planet, reset the current target planet
      currentTargetPlanet = null;
    }
  }


  // Add an event listener for mouse clicks
  window.addEventListener('click', onMouseClick);



  // // Function to handle mouse clicks
  // function onMouseClick(event) {
  //     // Update mouse coordinates for click position
  //     mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
  //     mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

  //     // Raycasting to detect intersection
  //     raycaster.setFromCamera(mouse, camera);
  //     const intersects = raycaster.intersectObjects(planetOrbitsAndMeshes.map(p => p.planetMesh));

  //     if (intersects.length > 0) {
  //         const clickedPlanet = intersects[0].object;

  //         // Get the index of the clicked planet
  //         const planetIndex = planetOrbitsAndMeshes.findIndex(p => p.planetMesh === clickedPlanet);
  //         const targetPosition = planetPositions[planetIndex]; // Access stored position

  //         // Show the modal instead of moving the camera immediately
  //         confirmationModal.style.display = 'block'; // Show modal
  //     } else {
  //         // If click is outside any planet, reset the current target planet
  //         currentTargetPlanet = null;
  //     }
  // }


  // Renderer setup
  const renderer = new THREE.WebGLRenderer();
  renderer.setSize(window.innerWidth, window.innerHeight);
  document.body.appendChild(renderer.domElement);

  // Scene and Camera setup for the main solar system (scene1)
  const scene = new THREE.Scene();
  const camera = new THREE.PerspectiveCamera(45, window.innerWidth / window.innerHeight, 0.1, 6000000);
  const orbit = new OrbitControls(camera, renderer.domElement);
  orbit.enableDamping = true;
  orbit.dampingFactor = 0.25;
  orbit.enableZoom = true;
  orbit.enablePan = true;

  // Initial camera position
  // const initialCameraDistance = 3500; // Starting distance from the Sun
  // camera.position.set(6000, 6000, initialCameraDistance);
  // camera.lookAt(0, 0, 0); // Look at the center (the Sun)
  orbit.update();


  // Lighting setup for scene1
  const ambientLight = new THREE.AmbientLight(0x333333);
  scene.add(ambientLight);

  // Sphere background setup for scene1
  const sphereGeometry = new THREE.SphereGeometry(20000, 32, 32);
  const sphereMaterial = new THREE.MeshBasicMaterial({
    map: new THREE.TextureLoader().load(starsTexture),
    side: THREE.BackSide // Ensures the texture is visible from the inside
  });
  const sphere = new THREE.Mesh(sphereGeometry, sphereMaterial);
  scene.add(sphere);

  // Create the Sun
  const sunGeo = new THREE.SphereGeometry(300, 30, 30);
  const sunMat = new THREE.MeshStandardMaterial({
    map: new THREE.TextureLoader().load(sunTexture),
    emissive: new THREE.Color(0xffff00), // Bright yellow emissive color
    emissiveIntensity: 1.5 // Intensity of the emissive glow
  });
  const sun = new THREE.Mesh(sunGeo, sunMat);
  scene.add(sun);

  // Create a Point Light for the Sun
  const sunLight = new THREE.PointLight(0xffff00, 2, 100); // Color and intensity
  sunLight.position.set(0, 0, 0); // Position at the Sun's location
  scene.add(sunLight);

  // Add bloom effect for scene1
  const composer = new EffectComposer(renderer);
  const renderPass = new RenderPass(scene, camera);
  composer.addPass(renderPass);

  // Increase the strength, radius, and adjust the threshold for the bloom effect
  const bloomStrength = 2.5; // Increase the intensity of the bloom effect
  const bloomRadius = 1.0; // Increase the spread of the bloom
  const bloomThreshold = 0.5; // Adjust the threshold to include more pixels

  const bloomPass = new UnrealBloomPass(
    new THREE.Vector2(window.innerWidth, window.innerHeight),
    bloomStrength,
    bloomRadius,
    bloomThreshold
  );
  composer.addPass(bloomPass);

  // Function to create planets
  function createPlanet(size, texture, position, ring, name) {
    const geo = new THREE.SphereGeometry(size, 30, 30);
    const textureLoader = new THREE.TextureLoader();
    const mat = new THREE.MeshStandardMaterial({
      map: textureLoader.load(texture)
    });
    const mesh = new THREE.Mesh(geo, mat);
    mesh.name = name; // Set the name for the planet mesh
    const obj = new THREE.Object3D();

    obj.position.set(position, 0, 0);
    obj.add(mesh);

    if (ring) {
      const ringGeo = new THREE.RingGeometry(ring.innerRadius, ring.outerRadius, 32);
      const ringMat = new THREE.MeshBasicMaterial({
        map: textureLoader.load(ring.texture),
        side: THREE.DoubleSide
      });
      const ringMesh = new THREE.Mesh(ringGeo, ringMat);
      obj.add(ringMesh);
      ringMesh.position.set(0, 0, 0);
      ringMesh.rotation.x = -0.5 * Math.PI;
    }

    scene.add(obj);
    return { mesh, obj };
  }



  // Create Raycaster for hover detection
  const raycaster = new THREE.Raycaster();
  const mouse = new THREE.Vector2();

  // Function to create an orbital path
  function createOrbit(radius, color) {
    const points = [];
    const segments = 64;
    for (let i = 0; i <= segments; i++) {
      const angle = (i / segments) * Math.PI * 2;
      points.push(new THREE.Vector3(Math.cos(angle) * radius, 0, Math.sin(angle) * radius));
    }
    const orbitGeo = new THREE.BufferGeometry().setFromPoints(points);
    const orbitMat = new THREE.LineBasicMaterial({
      color: color,
      opacity: 0.9, // Initial opacity set to 0.3
      transparent: true
      // cursor:pointer
    });
    const orbitLine = new THREE.LineLoop(orbitGeo, orbitMat);
    scene.add(orbitLine);
    return orbitLine;
  }

  // Function to create a point light for each planet
  function createPlanetLight(position) {
    const light = new THREE.PointLight(0xFFFFFF, .3, 50000);
    light.position.x = position;
    light.visible = position < 50000; // Initially set the light's visibility based on the position
    scene.add(light);
    return light;
  }

  // Planet data
  const planetsData = [
    { planetName: "mercury", size: 155.2, texture: mercuryTexture, position: 1600, ring: null, orbitColor: 0x9768ac, speed: 0.004 },
    { planetName: "venus", size: 167.8, texture: venusTexture, position: 2500, ring: null, orbitColor: 0xb07919, speed: 0.0015 },
    { planetName: "earth", size: 168, texture: earthTexture, position: 3700, ring: null, orbitColor: 0x0099cc, speed: 0.001 },
    { planetName: "mars", size: 166, texture: marsTexture, position: 5300, ring: null, orbitColor: 0x9a4e19, speed: 0.0008 },
    { planetName: "jupiter", size: 174, texture: jupiterTexture, position: 6690, ring: null, orbitColor: 0xda8b72, speed: 0.0002 },
    { planetName: "saturn", size: 172, texture: saturnTexture, position: 8950, ring: { innerRadius: 52, outerRadius: 104, texture: saturnRingTexture }, orbitColor: 0xd5c187, speed: 0.00009 },
    { planetName: "uranus", size: 159, texture: uranusTexture, position: 10100, ring: { innerRadius: 39, outerRadius: 78, texture: uranusRingTexture }, orbitColor: 0x68ccda, speed: 0.00004 },
    { planetName: "neptune", size: 159, texture: neptuneTexture, position: 12550, ring: null, orbitColor: 0x708ce3, speed: 0.00009 },
    { planetName: "pluto", size: 170.8, texture: plutoTexture, position: 14450, ring: null, orbitColor: 0x8b4513, speed: 0.00009 }
  ];


  // Store initial angles and distances for each planet's orbit
  const planetOrbits = planetsData.map(planet => {
    return {
      angle: Math.random() * Math.PI * 2, // Random angle between 0 and 2*PI
      speed: planet.speed,                 // Use the speed from the planetsData
      distance: planet.position             // Use the distance from the planetsData
    };
  });
  console.log(planetOrbits);

  // Loop through planet data to create planets and their orbits
  const planetLights = [];
  // Store the orbits and planets for easy access
  const planetOrbitsAndMeshes = [];

  // Loop through planet data to create planets and their orbits
  planetsData.forEach((planet, index) => {
    const orbit = createOrbit(planet.position, planet.orbitColor);
    const planetObject = createPlanet(planet.size, planet.texture, planet.position, planet.ring, `planet_${index}`); // Unique name
    const light = createPlanetLight(planet.position);
    planetLights.push({ object: planetObject.obj, light });

    planetOrbitsAndMeshes.push({
      orbit: orbit,
      planetMesh: planetObject.mesh,
      position: {
        x: planetObject.obj.position.x,
        y: planetObject.obj.position.y,
        z: planetObject.obj.position.z
      }
    });
  });

  console.log(planetOrbitsAndMeshes);




  // // Add event listener for click
  // window.addEventListener('click', onMouseClick);
  // function onMouseClick(event) {
  //   // Update the mouse variable with normalized device coordinates
  //   mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
  //   mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

  //   // Update the raycaster with the camera and mouse position
  //   raycaster.setFromCamera(mouse, camera);

  //   // Calculate objects intersecting the picking ray
  //   const intersects = raycaster.intersectObjects(planetOrbitsAndMeshes.map(planet => planet.planetMesh));

  //   if (intersects.length > 0) {
  //     const clickedPlanet = intersects[0].object;

  //     // Create a message asking for confirmation
  //     const planetName = clickedPlanet.name.charAt(0).toUpperCase() + clickedPlanet.name.slice(1); // Capitalize first letter for display
  //     const confirmRedirect = confirm(`Do you want to go to the ${planetName} page?`);

  //     // Redirect based on user confirmation
  //     if (confirmRedirect) {
  //       switch (clickedPlanet.name) {
  //         case 'mercury':
  //           window.location.href = 'mercury.html'; // Redirect to Mercury page
  //           break;
  //         case 'venus':
  //           window.location.href = 'venus.html'; // Redirect to Venus page
  //           break;
  //         case 'earth':
  //           window.location.href = 'earth.html'; // Redirect to Earth page
  //           break;
  //         // Add cases for other planets as needed
  //         default:
  //           break;
  //       }
  //     }
  //   }
  // }





  // Array of galaxy data
  const galaxies = [
    {
      name: 'Milky Way Galaxy',
      img: milkyWayGalaxy,
      description: "The Milky Way Galaxy, our home galaxy, is a barred spiral galaxy that contains an estimated 100 to 400 billion stars, along with countless planets, nebulae, and other celestial objects. It is about 100,000 light-years in diameter and features a distinctive barred structure at its center, where a supermassive black hole, known as Sagittarius A*, resides. The galaxy is composed of several distinct components: the galactic bulge, which houses older stars and the central black hole; the galactic disk, where young stars, gas, and dust reside; and the galactic halo, which contains older stars and globular clusters. Our solar system is located in one of the spiral arms known as the Orion Arm, approximately 27,000 light-years from the galactic center. Observations of the Milky Way have been enhanced by various space telescopes, including the Hubble Space Telescope and the James Webb Space Telescope. These observations reveal the dynamic processes of star formation occurring in regions such as the Orion Nebula and the Carina Nebula. Infrared observations allow astronomers to peer through the dense clouds of dust that obscure visible light, revealing the birthplaces of new stars and the complex interactions between stellar populations. The Milky Way is also part of the Local Group, a collection of over 50 galaxies, including the Andromeda Galaxy and the Triangulum Galaxy. Understanding the structure and behavior of the Milky Way is crucial for astronomers as it provides insights into the formation and evolution of galaxies across the universe. Its complex dynamics, rich star populations, and cosmic interactions continue to be a focus of astronomical research, shedding light on the history and future of our galaxy.",
    },
    {
      name: 'NGC 5468',
      img: galaxy1,
      description: "This image of NGC 5468, a galaxy located about 130 million light-years from Earth, combines data from the Hubble and James Webb space telescopes. This is the farthest galaxy in which Hubble has identified Cepheid variable stars. These are important milepost markers for measuring the expansion rate of the universe. The distance calculated from Cepheids has been cross-correlated with a type Ia supernova in the galaxy. Type Ia supernovae are so bright they are used to measure cosmic distances far beyond the range of the Cepheids, extending measurements of the universe's expansion rate deeper into space.",
    },
    {
      name: 'Multiwavelength View of NGC 1300',
      img: galaxy2,
      description: "This image of spiral galaxy NGC 1300 combines multiple observations to map stellar populations and gas. Radio light observed by the Atacama Large Millimeter/submillimeter Array (ALMA), represented in yellow, highlights the clouds of cold molecular gas that provide the raw material from which stars form. Data from the Very Large Telescope’s Multi Unit Spectroscopic Explorer (MUSE) instrument is represented in red and magenta, capturing the impact of young, massive stars on their surrounding gas. Visible light captured by the Hubble Space Telescope highlights dust lanes in gold and very young, hot stars in blue. High-resolution infrared images from the Webb Space Telescope will help researchers identify where stars are forming behind dust and study the earliest stages of star formation in this galaxy.",
    },
    {
      name: 'Multiwavelength View of NGC 3351',
      img: galaxy3,
      description: "This image of spiral galaxy NGC 3351 combines observations from several observatories to reveal details about its stars and gas. Radio observations from the Atacama Large Millimeter/submillimeter Array (ALMA) show dense molecular gas in magenta. The Very Large Telescope’s Multi Unit Spectroscopic Explorer (MUSE) instrument highlights where young massive stars illuminate their surroundings, set off in red. The Hubble Space Telescope’s images highlight dust lanes in white and newly formed stars in blue. High-resolution infrared images from the Webb Space Telescope will help researchers identify where stars are forming behind dust and study the earliest stages of star formation in this galaxy.",
    },
    {
      name: 'NGC 1433',
      img: galaxy4,
      description: "This image taken by NASA’s James Webb Space Telescope shows one of a total of 19 galaxies targeted for study by the Physics at High Angular resolution in Nearby Galaxies (PHANGS) collaboration. Nearby barred spiral galaxy NGC 1433 takes on a completely new look when observed by Webb’s Mid-Infrared Instrument (MIRI). NGC 1433’s spiral arms are littered with evidence of extremely young stars releasing energy and, in some cases, blowing out the gas and dust of the interstellar medium.Areas that appear dark and dim in optical imaging light up under Webb’s infrared eye.This is due to clumps of dust and gas in the interstellar medium absorbing the light from forming stars and emitting it back out in the infrared. Webb’s image of NGC 1433 is a strong display of how dynamic processes associated with forming stars influence the larger structure of an entire galaxy. At the center of the galaxy, a tight, bright core featuring a unique double ring structure shines in exquisite detail with Webb’s extreme resolution. In this case, that ‘double ring’ is actually tightly wrapped spiral arms that wind into an oval shape along the galaxy’s bar. NGC 1433 is a Seyfert galaxy, which are typically relatively close to Earth and has a supermassive black hole at the center eating material at a high rate.The brightness and lack of dust in the MIRI image of NGC 1433 could hint at a recent collision with another galaxy. NGC 1433 lies over 46 million light- years away from Earth in the constellation Horologium. MIRI was contributed by ESA and NASA, with the instrument designed and built by a consortium of nationally funded European Institutes(The MIRI European Consortium) and NASA’s Jet Propulsion Laboratory, in partnership with the University of Arizona.",
    },
    {
      name: 'NGC 6946',
      img: galaxy5,
      description: "This image from the Kitt Peak National Observatory of NGC 6946 contextualizes the locations of Supernova 2004et and Supernova 2017eaw within the galaxy. Scientists using NASA’s James Webb Space Telescope’s MIRI (Mid-Infrared Instrument) found large amounts of dust within two Type II supernovae, Supernova 2004et (SN 2004et) and Supernova 2017eaw (SN 2017eaw), located 22 million light-years away from Earth in spiral galaxy NGC 6946. The large amounts of dust found in these supernovae using MIRI supports that supernovae played a key role in supplying dust to the early universe.",
    },
    {
      name: 'Webb-and Hubble Views of Spiral Galaxy NGC 4254',
      img: galaxy6,
      description: "Face-on spiral galaxy, NGC 4254, is split diagonally in this image: The James Webb Space Telescope’s observations appear at top left, and the Hubble Space Telescope’s on bottom right. Webb and Hubble’s images show a striking contrast, an inverse of darkness and light. Why? Webb’s observations combine near- and mid-infrared light and Hubble’s showcase visible and ultraviolet light. Dust absorbs ultraviolet and visible light, and then re-emits it in the infrared. In Webb's images, we see dust glowing in infrared light. In Hubble’s images, dark regions are where starlight is absorbed by dust. The individual Webb and Hubble images are available for download using the links on the left side of this page.",
    },
    {
      name: 'Webb-and Hubble Views of Spiral Galaxy NGC 2835',
      img: galaxy7,
      description: "Face-on spiral galaxy, NGC 2835, is split diagonally in this image: The James Webb Space Telescope’s observations appear at top left, and the Hubble Space Telescope’s on bottom right. Webb and Hubble’s images show a striking contrast, an inverse of darkness and light. Why? Webb’s observations combine near- and mid-infrared light and Hubble’s showcase visible and ultraviolet light. Dust absorbs ultraviolet and visible light, and then re-emits it in the infrared. In Webb's images, we see dust glowing in infrared light. In Hubble’s images, dark regions are where starlight is absorbed by dust. The individual Webb and Hubble images are available for download using the links on the left side of this page.",
    },
    {
      name: 'NGC 604',
      img: galaxy8,
      description: "This image from NASA’s James Webb Space Telescope’s MIRI (Mid-Infrared Instrument) of star-forming region NGC 604 shows how large clouds of cooler gas and dust glow in mid-infrared wavelengths. This region is a hotbed of star formation and home to more than 200 of the hottest, most massive kinds of stars, all in the early stages of their lives. In the MIRI view of NGC 604, there are noticeably fewer stars than Webb’s NIRCam image. This is because hot stars emit much less light at these wavelengths. Some of the stars seen in this image are red supergiants—stars that are cool but very large, hundreds of times the diameter of our Sun. The blue tendrils of material signify the presence of polycyclic aromatic hydrocarbons, or PAHs.",
    },
    {
      name: 'NGC 605',
      img: galaxy9,
      description: "This image from NASA’s James Webb Space Telescope’s NIRCam (Near-Infrared Camera) of star-forming region NGC 604 shows how stellar winds from bright, hot young stars carve out cavities in surrounding gas and dust. The bright orange streaks in this image signify the presence of carbon-based molecules known as polycyclic aromatic hydrocarbons, or PAHs. As you travel further from the immediate cavities of dust where the star is forming, the deeper red signifies molecular hydrogen. This cooler gas is a prime environment for star formation. Hydrogen ionized by ultraviolet radiation appears as a white and blue ghostly glow. NGC 604 is located in the Triangulum galaxy (M33), 2.73 million light-years away from Earth. It provides an opportunity for astronomers to study a high concentration of very young, massive stars in a relatively nearby region.",
    },
  ];
  function closeModal() {
    document.getElementById("galaxy-modal").style.display = "none";
  }
  // Show modal function
  function showGalaxyModal(galaxyData) {
    document.getElementById("galaxy-title").innerText = galaxyData.name;
    document.getElementById("galaxy-image").src = galaxyData.img;
    document.getElementById("galaxy-description").innerText = galaxyData.description;

    document.getElementById("galaxy-modal").style.display = "block";
  }



  // Declare circleMesh and other variables
  let circleMesh;
  const galaxyMeshes = [];
  let spiralMesh;

  // Galaxy textures array with names
  const galaxyTextures = [
    { name: 'NGC-5468', texture: galaxy1 },
    { name: 'Multiwavelength-View-of-NGC-1300', texture: galaxy2 },
    { name: 'Multiwavelength-View-of-NGC-3351', texture: galaxy3 },
    { name: 'NGC-1433', texture: galaxy4 },
    { name: 'NGC-6946', texture: galaxy5 },
    { name: 'Webb-and-Hubble-Views-of-Spiral-Galaxy-NGC-4254', texture: galaxy6 },
    { name: 'Webb-and-Hubble-Views-of-Spiral-Galaxy-NGC-2835', texture: galaxy7 },
    { name: 'NGC-604', texture: galaxy8 },
    { name: 'NGC-605', texture: galaxy9 }
  ];

  // Load the Milky Way texture and set it for the circle mesh
  const loader = new THREE.TextureLoader();
  loader.load(milkyWayGalaxy, (texture) => {
    // Set texture to not repeat and center it
    texture.wrapS = THREE.ClampToEdgeWrapping; // Prevent horizontal repeat
    texture.wrapT = THREE.ClampToEdgeWrapping; // Prevent vertical repeat
    texture.needsUpdate = true; // Make sure to update the texture

    // Create a circular surface (plane) with the Milky Way texture
    const radius = 60000;
    const segments = 100;
    const circleGeometry = new THREE.CircleGeometry(radius, segments);

    // Create a material using the Milky Way texture without lights affecting it
    const circleMaterial = new THREE.MeshBasicMaterial({ map: texture, side: THREE.DoubleSide });
    circleMesh = new THREE.Mesh(circleGeometry, circleMaterial);

    // Position the circle mesh at y = 50000
    circleMesh.position.set(0, 100000, 0);
    circleMesh.rotation.x = Math.PI / 2;
    scene.add(circleMesh);

    // Add event listener for clicking on the Milky Way galaxy
    circleMesh.callback = () => {
      console.log('You clicked on the Milky Way galaxy!');

      // Show the modal with details about the Milky Way
      showGalaxyModal(galaxies[0]); // Pass the Milky Way data from the galaxies array
    };

    // Add raycasting for detecting clicks
    window.addEventListener('click', (event) => {
      const mouse = new THREE.Vector2(
        (event.clientX / window.innerWidth) * 2 - 1,
        -(event.clientY / window.innerHeight) * 2 + 1
      );
      const raycaster = new THREE.Raycaster();
      raycaster.setFromCamera(mouse, camera);
      const intersects = raycaster.intersectObject(circleMesh, true);

      if (intersects.length > 0) {
        const intersectedObject = intersects[0].object;
        if (intersectedObject.callback) {
          intersectedObject.callback();  // Call the show galaxy modal function on click
        }
      }
    });
  });


  // Add event listener for other galaxies
  galaxyTextures.forEach((galaxyData, index) => {
    loader.load(galaxyData.texture, (texture) => {
      texture.wrapS = THREE.ClampToEdgeWrapping;
      texture.wrapT = THREE.ClampToEdgeWrapping;
      texture.needsUpdate = true;

      const radius = 60000 + Math.random() * 150000;
      const segments = 50 + Math.floor(Math.random() * 50);
      const inclinationAngle = Math.random() * Math.PI / 4;

      const additionalCircleGeometry = new THREE.CircleGeometry(radius, segments);
      const additionalCircleMaterial = new THREE.MeshBasicMaterial({ map: texture, side: THREE.DoubleSide });
      const additionalCircleMesh = new THREE.Mesh(additionalCircleGeometry, additionalCircleMaterial);

      const angle = (index / galaxyTextures.length) * Math.PI * 2;
      const distanceFromCenter = 700000;
      additionalCircleMesh.position.set(Math.cos(angle) * distanceFromCenter, 50000, Math.sin(angle) * distanceFromCenter);
      additionalCircleMesh.rotation.x = Math.PI / 2 + inclinationAngle;

      scene.add(additionalCircleMesh);

      galaxyMeshes.push(additionalCircleMesh);

      // Store the galaxy data in userData for reference when clicked
      additionalCircleMesh.userData.galaxyData = galaxies[index + 1];  // Milky Way is index 0, so shift by +1

      additionalCircleMesh.callback = () => {
        console.log(`You clicked on ${additionalCircleMesh.userData.galaxyData.name}`);
        // Show the modal with galaxy data
        showGalaxyModal(additionalCircleMesh.userData.galaxyData);
      };

      // Raycast to detect clicks
      window.addEventListener('click', (event) => {
        const mouse = new THREE.Vector2(
          (event.clientX / window.innerWidth) * 2 - 1,
          -(event.clientY / window.innerHeight) * 2 + 1
        );
        const raycaster = new THREE.Raycaster();
        raycaster.setFromCamera(mouse, camera);
        const intersects = raycaster.intersectObjects(galaxyMeshes);

        if (intersects.length > 0) {
          const intersectedGalaxy = intersects[0].object;
          if (intersectedGalaxy.callback) {
            intersectedGalaxy.callback();
          }
        }

      });
      // Add animation for the galaxy
      const animateGalaxy = () => {
        requestAnimationFrame(animateGalaxy);
        additionalCircleMesh.position.z += Math.sin(Date.now() * 0.001 + index) * 0.1;
        additionalCircleMesh.rotation.z += 0.001;
        additionalCircleMesh.position.x += Math.sin(Date.now() * 0.001 + index) * 0.05;
      };
      animateGalaxy();
    });
  });
  // Function to toggle visibility of all objects in the scene
  // function setSceneVisibility(isVisible) {
  //   // Toggle visibility of the sun, planets, orbits, spiral, etc.
  //   sun.visible = isVisible;
  //   planetLights.forEach(planet => {
  //     planet.object.visible = isVisible; // Hide/show planets
  //   });
  //   planetOrbitsAndMeshes.forEach(planet => {
  //     planet.orbit.visible = isVisible; // Hide/show orbits
  //   });
  //   if (spiralMesh) {
  //     spiralMesh.visible = isVisible; // Hide/show spiral
  //   }
  //   pointsAroundSun.visible = isVisible; // Hide/show points around the sun

  //   // Toggle visibility for galaxy meshes
  //   if (galaxyMeshes.length > 0) {
  //     galaxyMeshes.forEach((galaxyMesh) => {
  //       galaxyMesh.visible = isVisible; // Show/Hide based on visibility flag
  //     });
  //   }
  // }




  // Light source for the Sun
  const pointLight = new THREE.PointLight(0xFFFFFF, 1.5, 10000);
  scene.add(pointLight);

  // Handle hover interaction with Raycaster
  function onMouseMove(event) {
    // Update mouse coordinates
    mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

    // Raycasting to detect intersection
    raycaster.setFromCamera(mouse, camera);
    const intersects = raycaster.intersectObjects(planetOrbitsAndMeshes.map(p => p.planetMesh));

    // Reset all orbits to initial opacity
    planetOrbitsAndMeshes.forEach(p => {
      p.orbit.material.opacity = 0.3;
    });


    // If hovering over a planet, change its orbit opacity to 1
    if (intersects.length > 0) {
      const hoveredPlanet = intersects[0].object;
      const matchedOrbit = planetOrbitsAndMeshes.find(p => p.planetMesh === hoveredPlanet);
      if (matchedOrbit) {
        matchedOrbit.orbit.material.opacity = 1;

        // Change cursor to pointer
        document.body.classList.add('pointer');
      }
    } else {
      // Reset cursor when not hovering over a planet
      document.body.classList.remove('pointer');
    }
  }

  // Add event listener for mouse move
  window.addEventListener('mousemove', onMouseMove);


  // Function to create points around the Sun with Gaussian distribution
  function createPointsAroundSun(count, maxRadius, color) {
    const positions = [];
    const colors = [];

    for (let i = 0; i < count; i++) {
      // Generate a random radius using a Gaussian distribution
      const radius = Math.sqrt(Math.random()) * maxRadius; // Adjust for clustering in the center

      // Generate random angles
      const theta = Math.random() * Math.PI * 9; // Random angle for rotation around the Y-axis
      const phi = Math.acos(1 - Math.random() * 9); // Random angle for elevation

      // Spherical to Cartesian conversion
      const x = radius * Math.sin(phi) * Math.cos(theta); // X position
      const y = radius * Math.sin(phi) * Math.sin(theta) / 3; // Y position
      const z = radius * Math.cos(phi); // Z position

      // Add position to array
      positions.push(x, y, z); // Spread in all dimensions

      // Push color for each point (using #0099cc)
      colors.push(0x00, 153, 204); // RGB components for #0099cc
    }

    // Create BufferGeometry
    const geometry = new THREE.BufferGeometry();

    // Set positions
    geometry.setAttribute('position', new THREE.Float32BufferAttribute(positions, 3));

    // Set colors
    geometry.setAttribute('color', new THREE.Float32BufferAttribute(colors, 3));

    // Create Points material
    const material = new THREE.PointsMaterial({
      size: 1, // Size of the points
      vertexColors: true // Use the colors defined in the geometry
    });

    // Create the Points object
    const points = new THREE.Points(geometry, material);
    return points;
  }

  // Create and add points around the Sun
  const pointsCount = 4000; // Number of points
  const pointsMaxRadius = 13000; // Maximum distance from the center
  const pointsColor = 0x0099cc; // Color
  const pointsAroundSun = createPointsAroundSun(pointsCount, pointsMaxRadius, pointsColor);
  scene.add(pointsAroundSun);
  scene.add(pointsAroundSun);

  // Declare a new array to store positions
  const planetPositions = [];
  // Declare variables
  // Declare variables in a higher scope
  let spiralGeometry, spiralMaterial;
  const sunPosition = new THREE.Vector3(0, 0, 0); // Position of the sun
  const spiralRadius = 18000; // Radius of the spiral's orbit
  let angle = 0; // Initial angle for circular motion
  let spiralRotationAngle = 0; // Rotation angle for the spiral

  function createSpiral() {
    spiralGeometry = new THREE.BufferGeometry();
    const spiralArms = 6;
    const pointsPerArm = 200;
    const positions = new Float32Array(spiralArms * pointsPerArm * 3);
    let index = 0;

    for (let i = 0; i < spiralArms; i++) {
      const angleOffset = (i / spiralArms) * Math.PI * 2;
      for (let j = 0; j < pointsPerArm; j++) {
        const angle = j * (Math.PI * 2) / pointsPerArm;
        const radius = spiralRadius * (j / pointsPerArm);
        const x = Math.cos(angle + angleOffset) * radius;
        const y = Math.sin(angle + angleOffset) * radius;
        const z = Math.random() * 10000 - 5000;

        positions[index++] = x;
        positions[index++] = y;
        positions[index++] = z;
      }
    }

    spiralGeometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));
    spiralMaterial = new THREE.PointsMaterial({ size: 1, color: 0xffffff });
    spiralMesh = new THREE.Points(spiralGeometry, spiralMaterial);

    // Tilt the spiral mesh at a 90-degree angle (π/2 radians) along the X-axis
    spiralMesh.rotation.x = Math.PI / 2; // Rotate 90 degrees around X-axis

    scene.add(spiralMesh); // Add to scene here or wherever appropriate
  }

  // Call this function to create the spiral
  createSpiral();

  // Animation loop
  function animate() {
    // Self-rotation of the Sun
    sun.rotation.y += 0.07;
    if (circleMesh) { // Check if circleMesh is defined
      circleMesh.rotation.z += 0.006; // Adjust rotation speed as needed
    }

    // Self-rotation of planets
    planetLights[0].object.children[0].rotation.y += 0.05; // Mercury
    planetLights[1].object.children[0].rotation.y += 0.04; // Venus
    planetLights[2].object.children[0].rotation.y += 0.03; // Earth
    planetLights[3].object.children[0].rotation.y += 0.01; // Mars
    planetLights[4].object.children[0].rotation.y += 0.01; // Jupiter
    planetLights[5].object.children[0].rotation.y += 0.005; // Saturn
    planetLights[6].object.children[0].rotation.y += 0.004; // Uranus
    planetLights[7].object.children[0].rotation.y += 0.003; // Neptune
    planetLights[8].object.children[0].rotation.y += 0.001; // Pluto

    // Orbiting planets around the Sun
    planetOrbits.forEach((orbit, index) => {
      orbit.angle += orbit.speed; // Update angle based on speed
      const x = Math.cos(orbit.angle) * orbit.distance; // New X position
      const z = Math.sin(orbit.angle) * orbit.distance; // New Z position
      planetLights[index].object.position.set(x, 0, z); // Update planet position
      planetLights[index].light.position.set(x, 0, z); // Update planet light position

      // Store the current positions in the planetPositions array
      planetPositions[index] = { x, z }; // Store only x and z for camera movement
    });

    // Get the current camera distance from the origin
    const cameraDistance = camera.position.length();

    // Set visibility based on camera distance
    const visibilityThreshold = 99999; // Define the distance threshold

    // Check if camera distance is greater than the threshold
    const isVisible = cameraDistance <= visibilityThreshold;

    // Set visibility for sun, planets, orbits, and spiral
    sun.visible = isVisible;
    planetLights.forEach(planet => {
      planet.object.visible = isVisible; // Hide/show planets
    });
    planetOrbitsAndMeshes.forEach(planet => {
      planet.orbit.visible = isVisible; // Hide/show orbits
    });
    if (spiralMesh) {
      spiralMesh.visible = isVisible; // Hide/show spiral
    }
    pointsAroundSun.visible = isVisible; // Hide/show points around the sun

    // Sphere background setup for scene1
    sphere.visible = sphere.position.y >= 50000; // Ensure the sphere is also hidden below height

    // Hide circleMesh when camera distance is less than 100,000
    if (circleMesh) {
      circleMesh.visible = cameraDistance >= 100000; // Show/Hide based on camera distance
    }
    // Hide each galaxy mesh based on camera distance
    if (galaxyMeshes.length > 0) {
      galaxyMeshes.forEach((galaxyMesh) => {
        galaxyMesh.visible = cameraDistance >= 99999; // Show/Hide based on camera distance
      });
    }


    // Update orbit controls
    orbit.update();
    composer.render();

    // Continue the animation loop
    requestAnimationFrame(animate);
  }



  // Handle window resize
  window.addEventListener('resize', () => {
    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();
    renderer.setSize(window.innerWidth, window.innerHeight);
    composer.setSize(window.innerWidth, window.innerHeight);
  });

  // Start animation loop
  animate();


}